import { autoinject, bindable, bindingMode, customElement } from 'aurelia-framework';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { BaseCustomElement } from 'Common/BaseCustomElement';

@autoinject
@customElement('edit4')
export class Edit4CustomElement extends BaseCustomElement {
}